import React, { useEffect, useRef, useState } from "react";
import Loadspinner from "../../../common/Loadspinner";
import CommonService from "../../../services/CommonService";
import { Modal } from "@material-ui/core";
import CreateKnowledgeService from "../../../services/CreateKnowledgeService";
import PropTypes, { number } from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Redirect } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as images from "../../../constants/Images";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../../firebase";
import { APICall } from "../../../helpers/API/APICalls";
import moment from "moment";
import {
  checkDoc,
  getCommonDropdownData,
  getHashtagsAutoComplete,
  insertNewGeneratedHashtagsInMaster,
} from "../../../helpers/API/APIEndPoints";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";

import SelectForm from "../../../ReusableComponents/SelectForm/SelectForm";
import SelectFormCreatableV2 from "../../../ReusableComponents/SelectForm/SelectFormCreatableV2";
import { Collapse, Paper } from "@mui/material";
import { Button, Image } from "react-bootstrap";
import CommonConstants from "../../../constants/CommonConstants";
import FileExtensionAllowed from "../../../helpers/FileExtensionAllowed.js/FileExtensionAllowed";
import { getFromEncLocalStorage } from "../../../helpers/Utils/Utils";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";

//import axios from "axios";

export function CircularProgressWithLabel(props) {
  return (
    <Box
      position="relative"
      display="inline-flex"
      borderColor="grey"
      style={{ justifyContent: "center", alignItems: "center" }}
    >
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          style={{
            fontSize: "14px",
            color: "blue",
            textAlign: "center",
            marginLeft: "70px",
          }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

function UploadDocument(props) {
  const [divisionId, setDivisionId] = useState(1);
  const [platformId, setPlatformId] = useState(0);
  const [systemId, setSystemId] = useState(0);
  const [subSystemId, setSubsystemId] = useState(0);

  const [aggregate, setAggregate] = useState(0);

  const [aggregateList, setAggregateList] = useState([]);
  const [selectedCoeHideList, setSelectedCoeHideList] = useState([]);
  const [location, setLocation] = useState("");

  const [status, setStatus] = useState(0);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [fileName, setFilename] = useState("");
  const [fileType, setFileType] = useState("");
  const [fileDisplayType, setFileDisplayType] = useState("");
  const [videoId, setVideoId] = useState("");
  const [firstToken, setToken] = useState("");
  const [keywords, setKeywords] = useState("");
  const [hashtag, setHashtags] = useState("");
  const [hashtagArray, setHashtagsArray] = useState([]);
  const [usersArray, setUserArray] = useState([]);
  const [selectedHideUsersArray, setSelectedHideUsersArray] = useState([]);

  const [tagusersArray, setTagUserArray] = useState([]);
  const [selectedTagusersArray, setSelectedTagusersArray] = useState([]);

  const [selectedhashtagArray, setSelectedHashtagsArray] = useState([]);

  const [coeHideList, setCoeHideList] = useState([]);

  const [globalFDPD, setGlobalFDPD] = useState(true);
  const [isGlobalFDPD, setIsGlobalFDPD] = useState(true);
  const [globalFDPDClass, setGlobalFDPDClass] = useState(
    "row rowMargin disabledDiv",
  );
  const [attachment, setAttachment] = useState();
  const [platformList, setPlatformList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [systemList, setSystemList] = useState([]);
  const [subSystemList, setSubsystemList] = useState([]);
  const [isSystem, setIsSystem] = useState(true);
  const [isLoading, setLoading] = useState(false);
  // const [isSubmit, setSubmit] = useState(true);
  const [isProgress, setProgress] = useState(false);
  const [progressStatus, setProgStatus] = useState(0);
  const [thumbnailId, setThumbnailId] = useState("");
  const [transcriptionData, setTranscriptionData] = useState("");
  const [success, setSuccess] = useState(false);
  const [thumbnailFilename, setThumbnailFilename] = useState();
  const [thumbnail, setThumbnail] = useState();
  const inputFileRef = useRef();

  // const [isAttachment, setIsAttachment] = useState(false);
  const [progressBar, setProgressBar] = useState(0);

  const [videoInGlobalUrl, setVideoInGlobalUrl] = useState(null);
  const [videoInFilename, setVideoInFilename] = useState(null);
  const [videoInDocumentType, setVideoInDocumentType] = useState(null);
  const [videoInDocValidationResponse, setVideoInDocValidationResponse] =
    useState(null);
  console.log(
    "getFromEncLocalStorage(userId): ",
    getFromEncLocalStorage("userId"),
  );

  const [showModal, setModal] = useState(true);

  const allowedExtensions = [
    "webm",
    "mp3",
    "ppt",
    "docx",
    "pdf",
    "xlsx",
    "jpg",
    "jpeg",
    "png",
    "mp4",
  ];
  const closeModal = () => {
    setModal(false);
    props.handleModal(false);

    setStatus(0);
    setDivisionId(1);
    setPlatformId("");
    setSystemId("");
    setSystemId("");
    setIsSystem(false);
    setTitle("");
    setDescription("");
    setFilename("");
    setFileType("");
    setAttachment("");
    setThumbnail("");
    setThumbnailFilename("");
  };

  // const pattern = "!@#$%^&*()+=-[]\\';,./{}|\":<>?";
  useEffect(() => {
    getLists();
  }, []);

  const progressFn = (percentage, label = "Upload") => {
    setProgressBar({ progress: percentage, label: label });
  };

  // useEffect(() => {
  //   console.log("🚀 ~ file: UploadDocument.js:190 ~ useEffect ~ inputFileRef1:", inputFileRef1);
  //   if (inputFileRef1 && inputFileRef1.current) {
  //     resumable = new Resumable({
  //       target: checkDocResumable, // Express.js backend URL
  //       chunkSize: 90 * 1024 * 1024, // 90MB chunk size
  //       forceChunkSize: true,
  //       query: { upload_token: moment().format("YYYYMMDD_HHmmss") }, // Additional query parameters
  //       maxFiles: 1,
  //       testChunks: false, // Skip chunk existence checks
  //       simultaneousUploads: 1,
  //       withCredentials: true,
  //       setChunkTypeFromFile: true,
  //       headers: {
  //         "Access-Control-Allow-Origin": "https://97f6-202-179-73-174.ngrok-free.app",
  //         "Access-Control-Allow-Headers": "*",
  //       },
  //     });
  //     //resumable.assignBrowse(inputFileRef1.current);
  //   }
  // }, [inputFileRef1.current]);

  const getLists = () => {
    getAggregate();
    getSystem(1);
    getDivision();
    getPlatform(1);
    getToken();
    getCoeHidden();
    getAllTagUsers();
  };

  const getAggregate = async () => {
    let requestParams = {
      dropdownName: "aggregate",
      searchText: "",
    };
    const resp = await APICall(getCommonDropdownData, requestParams, "POST");

    if (resp.data.length > 0) {
      setAggregateList(resp.data);
    } else {
      setAggregateList([]);
    }
  };
  const handleTitleChange = (e) => {
    let val = e.target.value.replace(/[$&[\]|<>^*/]/, "");
    setTitle(val);
  };

  const handleDescriptionChange = (e) => {
    let val = e.target.value.replace(/[$&[\]|<>^*/]/, "");
    setDescription(val);
  };

  const onFDPDCheck = (event) => {
    setUserArray([]);
    setSelectedCoeHideList([]);
    setGlobalFDPD(event);
    setIsGlobalFDPD(event);
    if (!event) {
      setGlobalFDPDClass("row rowMargin");
    } else {
      setGlobalFDPDClass("row rowMargin disabledDiv");
    }
  };

  const getHashTags = async (event, cb) => {
    if (event.length >= 3) {
      let requestParams = {
        searchText: event,
      };
      const resp = await APICall(
        getHashtagsAutoComplete,
        requestParams,
        "POST",
      );
      if (resp.data.length > 0) {
        //console.log(resp.data);
        cb(resp.data);
      } else {
        cb([]);
      }
    }
  };
  const getAllUsers = async (event, cb) => {
    if (event.length >= 3) {
      let requestParams = {
        dropdownName: "getAllUsers",
        searchText: event,
      };
      const resp = await APICall(getCommonDropdownData, requestParams, "POST");
      if (resp.data.length > 0) {
        cb(resp.data);
      } else {
        cb([]);
      }
    }
  };

  const getAllTagUsers = async () => {
    let requestParams = {
      dropdownName: "getAllUsersDropdown",
    };
    const resp = await APICall(getCommonDropdownData, requestParams, "POST");
    if (resp.data.length > 0) {
      setTagUserArray(resp.data);
    } else {
      setTagUserArray([]);
    }
  };

  const onSelectChange = (event, controlName) => {
    if (controlName === "hashtag") {
      let array = [...event];

      setHashtagsArray(array);
    }
    if (controlName === "users") {
      let array = [...usersArray, ...event];

      setUserArray(array);
    }

    if (controlName === "tagusers") {
      let array = [...tagusersArray, ...event];

      setTagUserArray(array);
    }
  };
  const removeTag = (hashtagArr, id) => {
    let tempArray = hashtagArr;
    tempArray = tempArray.filter(function (obj) {
      return obj.value !== id;
    });
    setHashtagsArray(tempArray);
  };

  const removeUser = (arr, id) => {
    let tempArray = arr;
    tempArray = tempArray.filter(function (obj) {
      return obj.value !== id;
    });
    setUserArray(tempArray);
  };
  const onTextChange = async (e, controlName) => {
    if (controlName === "keywords") {
      setKeywords(e.target.value);
    }
    if (controlName === "location") {
      setLocation(e.target.value);
    }
    if (controlName === "hashtags") {
      setHashtags(e.target.value);
      if (e.target.value.length >= 3) {
        let requestParams = {
          searchText: e.target.value,
        };
        const resp = await APICall(
          getHashtagsAutoComplete,
          requestParams,
          "POST",
        );
        if (resp.data.length > 0) {
          setHashtagsArray(resp.data);
        }
      } else {
        setHashtagsArray([]);
      }
    }
  };
  //division
  const getDivision = async () => {
    setLoading(true);
    const res = await CommonService.getDivisionList();

    if (res) {
      setDivisionList(res);
    }
    setLoading(false);
  };

  const setDivision = (e) => {
    // console.log(e.target.value);
    setDivisionId(e.target.value);
    getPlatform(e.target.value);
    getSystem(e.target.value);
  };

  //platform
  const getPlatform = async (divId) => {
    setLoading(true);
    const res = await CommonService.getPlatformList(divId);

    if (res) {
      setPlatformList(res);
    }
    setLoading(false);
  };

  //system

  //Old method from kms
  const getSystem = async (divId) => {
    setLoading(true);
    const tempData = [];
    const res = await CommonService.getSystemList(divId);

    if (res) {
      res.forEach((element) => {
        tempData.push({
          label: element.system_desc,
          value: element.id,
          key: element.id,
        });
      });
      setSystemList(tempData);
    } else {
      setSystemList([]);
    }
    setLoading(false);
  };

  //Old method from common master
  // const getSystem = async (divId) => {
  //   setLoading(true);
  //   // const res = await CommonService.getSystemList(divId);

  //   // if (res) {
  //   //   setSystemList(res);
  //   // }

  //   let requestParams = {
  //     dropdownName: "coeCommonMaster",
  //     // searchText: 1, //Pass user id
  //     searchText: getFromEncLocalStorage("userId"), //Pass employeenumber
  //   };
  //   const resp = await APICall(getCommonDropdownData, requestParams, "POST");

  //   if (resp.data.length > 0) {
  //     setSystemList(resp.data);
  //   } else {
  //     setSystemList([]);
  //   }
  //   setLoading(false);
  // };

  //hidden coe
  const getCoeHidden = async () => {
    setLoading(true);

    let requestParams = {
      dropdownName: "allCoeCommonDropdown",
      searchText: 2,
    };
    const resp = await APICall(getCommonDropdownData, requestParams, "POST");

    if (resp.data.length > 0) {
      setCoeHideList(resp.data);
    } else {
      setCoeHideList([]);
    }
    setLoading(false);
  };
  const setSystem = (e) => {
    getSubsystem(e.target.value);
    setSystemId(e.target.value);
    if (e.target.value > 0) {
      setIsSystem(false);
    }
  };

  //subsystem

  const getSubsystem = async (id) => {
    setLoading(true);
    const res = await CommonService.getSubSystemList(id);

    if (res) {
      setSubsystemList(res);
    }
    setLoading(false);
  };

  //file

  const fileSelect = (e, type1) => {
    if (e.target.files.length > 0) {
      let { type } = e.target.files[0];
      let strarray = type.split("/");
      let strng = strarray[0];
      let fileValidations = FileExtensionAllowed(
        e.target.files[0],
        allowedExtensions,
      );
      console.log(`error Text`, fileValidations);

      if (fileValidations != "") {
        toast(fileValidations);
      } else {
        setFileDisplayType(strng);
        if (type1 == "thumbnail") {
          setThumbnailFilename(e.target.files[0].name);
          uploadFile(e.target.files[0], false, type1);
        } else {
          setFilename(e.target.files[0].name);
          if (strng === "video") {
            uploadVideoTrans(e.target.files[0]);
            setFileType(type);
          } else if (strng === "audio") {
            uploadFile(e.target.files[0], true, type);

            // audio is just send for transcripting
            // uploadVideoTrans(e.target.files[0]);
            // setAttachment(e.target.files[0]);
          } else {
            console.log("In else PArt: ", e.target.files[0], false, type);
            uploadFile(e.target.files[0], false, type);
            // setAttachment(e.target.files[0]);
          }
        }
      }
    }
  };

  const uploadFile = async (files, isAudio, type) => {
    let fileData = new FormData();
    fileData.append("file", files);

    let container = isAudio ? "audios" : "knowledge";
    setLoading(true);
    let resp = await CreateKnowledgeService.fileUpload(fileData, container);
    if (resp.status.toLowerCase() == "success") {
      if (type == "thumbnail") {
        setThumbnail(resp.result[0]);
      } else {
        setAttachment(resp.result[0]);
        setFileType(type);
      }
      // setSubmit(false);
    } else if (resp.status.toLowerCase() == "error") {
      setFilename("");
      if (resp.message.toLowerCase() == "invalid file format") {
        toast("Invalid File format");
      } else {
        toast("An error occurred while uploading the file. Please try again");
      }
    }
    setLoading(false);
  };

  //video transcription
  const uploadVideoTrans = async (FileData) => {
    // Azure Video Indexer 13 06 2024
    // console.log("uploadVideoTrans newFile: ", newFile);
    // let userToken = "";
    // const knowledgeData = new FormData();
    // knowledgeData.append("videofile", newFile);
    // console.log(newFile.name);
    // if (firstToken == "") {
    //   userToken = await getToken();
    // }
    // Azure Video Indexer 13 06 2024

    setLoading(true);
    let resp = await CreateKnowledgeService.uploadOnGCPVideoAudioNew(
      FileData,
      progressFn,
    );

    // Azure Video Indexer 13 06 2024
    // let resp = await CreateKnowledgeService.uploadVideo(
    //   firstToken ? firstToken : userToken,
    //   knowledgeData,
    //   newFile.name
    // );
    // Azure Video Indexer 13 06 2024

    // console.log("uploadVideoTrans resp: ", resp);
    debugger;
    if (resp?.data) {
      console.log("resp.data: ", resp.data);
      let { GlobalUrl, FileName, DocumentType, DocValidationResponse } =
        resp.data;
      setVideoInGlobalUrl(GlobalUrl);
      setVideoInFilename(FileName || DocValidationResponse.FileName);
      setVideoInDocumentType(DocumentType);
      setVideoInDocValidationResponse(DocValidationResponse);

      // let { id, name } = resp.data;
      // Azure Video Indexer 13 06 2024
      // setVideoId(id);
      // getDetails(name, id);
      // Azure Video Indexer 13 06 2024
    } else {
      setFilename("");
      toast(
        "An error occurred while uploading the video file. Please try again",
      );
    }
    setProgressBar(null);
    setLoading(false);
  };

  // const getDetails = async (fileName, videoId) => {
  //   // console.log("getDetails firstToken: ", firstToken);
  //   // console.log("getDetails id: ", id);
  //   setProgress(true);
  //   let resp = await CreateKnowledgeService.getVideoDetails1(
  //     firstToken,
  //     fileName,
  //     videoId
  //   );

  //   console.log("getDetails resp: ", resp);

  //   if (resp?.hasOwnProperty("results") && resp.results.length > 0) {
  //     let findVideoArray = resp.results.find((vid) => {
  //       return vid.id == videoId;
  //     });
  //     if (findVideoArray) {
  //       if (findVideoArray.processingProgress != "100%") {
  //         setTimeout(() => (resp = getDetails(fileName, videoId)), 3000);
  //         let status = parseInt(findVideoArray.processingProgress);
  //         setProgStatus(status);
  //       } else {
  //         setThumbnailId(findVideoArray.thumbnailId);
  //         getVideoToken(videoId);
  //         setProgStatus(100);
  //         setProgress(false);
  //       }
  //     }
  //   }
  // };

  const getVideoToken = async (id) => {
    let res = await CreateKnowledgeService.getVideoToken(id);
    if (res) {
      getTranscriptionData(id, res);
    }
  };

  const getTranscriptionData = async (id, tok) => {
    let res = await CreateKnowledgeService.getTranscription(id, tok);
    if (res) {
      let data = {
        transcript: res.videos[0].insights.transcript,
      };
      let transcript = JSON.stringify(data);
      setTranscriptionData(transcript);
    }
    setProgress(false);
  };

  //token

  const getToken = async () => {
    const res = await CreateKnowledgeService.firstApi();
    if (res) {
      setToken(res);

      return res;
    }
  };

  //upload

  const createKnowledge = async (e) => {
    e.preventDefault();
    let newHashtagArray = [];

    if (platformId == "") {
      toast("Please select platform");
    } else if (systemId == "") {
      toast("Please select COE");
    } else if (title == "") {
      // Swal.fire({
      //   text: "Title name is required",
      //   toast: true,
      // });
      toast("Please enter title");
    } else if (description == "") {
      toast("Please enter description");
    } else if (
      !globalFDPD &&
      selectedCoeHideList.length === 0 &&
      selectedHideUsersArray.length === 0
    ) {
      toast("Please select the COE or Users who can see");
    } else {
      //check if hashtags are present...if not then add them to master
      if (hashtagArray?.length > 0) {
        let elementsWithoutId = hashtagArray.filter(
          (hashtag) => typeof hashtag.value !== "number",
        );
        let elementsWithId = hashtagArray.filter(
          (hashtag) => typeof hashtag.value === "number",
        );

        elementsWithoutId = elementsWithoutId.filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.value === value.value),
        );
        //Insert hashtags without ids in master

        if (elementsWithoutId.length > 0) {
          let requestParams = {
            hashtagArray: elementsWithoutId,
            userId: getFromEncLocalStorage("userId"),
            createdDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
          };
          const resp = await APICall(
            insertNewGeneratedHashtagsInMaster,
            requestParams,
            "POST",
          );

          if (resp) {
            if (
              resp.message &&
              resp.message.toLowerCase().includes("duplicate")
            ) {
              notify(1, resp.message);
              return;
            }
            newHashtagArray = [...resp.data, ...elementsWithId];

            // window.location.reload();
          }
        } else {
          newHashtagArray = [...elementsWithId];
        }
      }
      debugger;
      let reqData = {
        VideoInGlobalUrl: videoInGlobalUrl,
        VideoInFilename: videoInFilename,
        VideoInDocumentType: videoInDocumentType,
        DocValidationResponse: videoInDocValidationResponse,
        title: title,
        status: status,
        description: description,
        division_id: divisionId,
        platform_id: platformId,
        system_id: systemId,
        subsystem_id: subSystemId,
        video_id: videoId,
        transcription_data: transcriptionData,
        thumbnailId: thumbnailId,
        thumbnail: thumbnail,
        thumbnailFilename: thumbnailFilename,
        attachment: attachment,
        attachment_file_name: videoInFilename || fileName,
        attachment_file_type: fileType,
        Keywords: keywords,
        AggreegateId: aggregate,
        HashtagIds: newHashtagArray.map((a) => a.value).toString(),
        RestrictedUserIds: selectedHideUsersArray
          .map((a) => a.value)
          .toString(),
        RestrictedCOEIds: selectedCoeHideList.map((a) => a.value).toString(),
        TaggedUserIds: selectedTagusersArray.map((a) => a.value).toString(),
        KnowledgeStatus: 2,
        UserId: Number(getFromEncLocalStorage("userId")),
        Location: location,
      };

      // const knowledgeData = new FormData();

      // knowledgeData.append("title", title);
      // knowledgeData.append("status", status);
      // knowledgeData.append("description", description);
      // knowledgeData.append("division_id", divisionId);
      // knowledgeData.append("platform_id", platformId);
      // knowledgeData.append("system_id", systemId);
      // knowledgeData.append("subsystem_id", subSystemId);
      // knowledgeData.append("video_id", videoId);
      // knowledgeData.append("transcription_data", transcriptionData);
      // knowledgeData.append("thumbnailId", thumbnailId);
      // knowledgeData.append("attachment", attachment);
      // knowledgeData.append("attachment_file_type", fileType);

      // knowledgeData.append("keywords", keywords);
      // knowledgeData.append("hashtagArray", hashtagArray);
      // knowledgeData.append("usersArray", usersArray);
      // knowledgeData.append("RestrictedCOEIds", RestrictedCOEIds);
      // knowledgeData.append("selectedTagusersArray", selectedTagusersArray);

      setLoading(true);

      console.log("reqData: ", reqData);
      const res = await CreateKnowledgeService.createKnowledge(reqData);
      if (res) {
        // //logEvent(analytics(), "createKnowledge");
        setLoading(false);

        window.location.reload();
        return <Redirect to="/home" />;
      }

      setLoading(false);
    }
  };

  const ProgressBarProcess = ({ progressBar }) => {
    if (progressBar?.progress < 0 || progressBar?.progress > 100) {
      return <p style={{ fontSize: "12px" }}>Processing Please Wait...</p>;
    } else {
      return (
        <>
          <p>
            {progressBar?.label} :{" "}
            {progressBar?.progress <= 100 && progressBar?.progress}%
          </p>
          <progress value={progressBar?.progress} max="100"></progress>
        </>
      );
    }
  };

  return (
    <div>
      <Loadspinner
        filename="UploadDocument.js"
        isLoading={isLoading}
        isMiddle="true"
      />
      {/* <div
        data-bs-toggle="modal"
        data-bs-target="#docUpload"
        onClick={getLists}
        style={{ cursor: "pointer", fontSize: "10px" }}
      >
        <img src={images.docs_upload} className="header-navimg-du" />
        <span className="header-text">Document upload</span>
      </div> */}

      {/* <div
        className="modal fade"
        id="docUpload"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="addInterestsLabel"
        aria-hidden="true"
      > */}
      <Modal
        open={showModal}
        onClose={closeModal}
        className="justify-space-around modal-dialog modal-lg modal-dialog-centered"
      >
        <div
          className="modal-content"
          style={{
            borderRadius: "25px",
            marginTop: "200px",
            marginBottom: "200px",
          }}
        >
          <Modal
            disablePortal
            disableEnforceFocus
            disableAutoFocus
            open={isProgress}
            style={{ background: "transparent" }}
          >
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%,-50%)",
              }}
            >
              <CircularProgressWithLabel
                value={Number.isNaN(progressStatus) ? 0 : progressStatus}
                style={{ width: "100px" }}
              />
              <p style={{ margin: "25px", color: "white" }}>
                Uploading {fileDisplayType}
              </p>
            </div>
          </Modal>
          <div className="modal-header">
            <h5 className="modal-title popup-header">Create Knowledge</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div
            className="modal-body"
            style={{ overflowY: "scroll", height: "550px" }}
          >
            <form>
              <div className="row card-row" style={{ fontWeight: "normal" }}>
                <div className="col-2 ">
                  <label
                    className="form-check-label"
                    style={{ marginRight: "20px" }}
                  >
                    Status
                  </label>
                </div>
                <div className="col-4">
                  <input
                    className="form-check-input"
                    type="radio"
                    value={status}
                    checked={status == 0}
                    onChange={() => setStatus(0)}
                    required
                    style={{ paddingRight: "5px" }}
                    autoComplete={CommonConstants.autoCompleteInput}
                  />
                  <label
                    className="form-check-label"
                    style={{ paddingLeft: "4px" }}
                  >
                    Work in progess
                  </label>
                </div>
                <div className="col-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    value={status}
                    checked={status == 1}
                    onChange={() => setStatus(1)}
                    required
                    autoComplete="off"
                  />
                  <label
                    className="form-check-label"
                    style={{ paddingLeft: "4px" }}
                  >
                    Proven
                  </label>
                </div>
              </div>
              <div className="row card-row" style={{ fontWeight: "normal" }}>
                {/* remove division */}
                {/* <div className="col-6 ">
                  <label
                    className="form-check-label"
                    // style={{ marginRight: "20px" }}
                  >
                    Division
                  </label>
                  {divisionList.map((division) => (
                    <div
                      className="form-check form-check-inline "
                      key={division.id}
                    >
                      <input
                        className="form-check-input"
                        type="radio"
                        value={division.id}
                        checked={divisionId == division.id ? true : false}
                        onChange={setDivision}
                      />
                      <label className="form-check-label ">
                        {division.division_desc}
                      </label>
                    </div>
                  ))}
                </div> */}
                <div className="col-6">
                  <label className="form-check-label">Platform</label>
                  <select
                    className="form-select"
                    required
                    onChange={(e) => setPlatformId(e.target.value)}
                    defaultValue={""}
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    {platformList.map((platform) => (
                      <option key={platform.id} value={platform.id}>
                        {platform.platform_desc}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="row card-row">
                <div className="col-6">
                  <label className="form-check-label">COE</label>
                  <select
                    className="form-select"
                    required
                    onChange={setSystem}
                    defaultValue={""}
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    {systemList.map((system) => (
                      <option key={system.value} value={system.value}>
                        {system.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* <div className="col-6">
                  <label className="form-check-label">Sub COE</label>
                  <select
                    className="form-select "
                    disabled={isSystem}
                    onChange={(e) => setSubsystemId(e.target.value)}
                    required
                  >
                    <option value="" disabled selected>
                      Select
                    </option>
                    {subSystemList.map((subSystem) => (
                      <option key={subSystem.id} value={subSystem.id}>
                        {subSystem.subsystem_desc}
                      </option>
                    ))}
                  </select>
                </div> */}

                <div className="col-6">
                  <label className="form-check-label">Aggregate</label>
                  <select
                    className="form-select "
                    disabled={false}
                    onChange={(e) => setAggregate(e.target.value)}
                    required
                    defaultValue={""}
                  >
                    <option value="" disabled>
                      Select
                    </option>
                    {aggregateList.map((subSystem) => (
                      <option key={subSystem.value} value={subSystem.value}>
                        {subSystem.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="row card-row">
                <label className="form-check-label">Title</label>
                <div className="col-12">
                  <textarea
                    className="form-control"
                    name="title"
                    onChange={handleTitleChange}
                    value={title}
                    rows="2"
                    placeholder="Enter here"
                    required
                  />
                </div>
              </div>
              <div className="row card-row">
                <label className="form-check-label">Detailed Description</label>
                <div className="col-12">
                  <textarea
                    className="form-control"
                    onChange={handleDescriptionChange}
                    name="description"
                    value={description}
                    id="exampleFormControlTextarea1"
                    rows="3"
                    placeholder="Enter here"
                    required
                    pattern="/^(?!\s)[A-Za-z0-9\s]+$/"
                  />
                </div>
              </div>
              <div className="row card-row">
                <label className="form-check-label">Upload File</label>
                <div className="col-12">
                  <div
                    className="drop-container"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      margin: 0,
                      height: "60px",
                      border: "2px dashed #ced4da",
                    }}
                  >
                    <div className="col-3">
                      <img
                        src={images.upload}
                        className="img-responsive"
                        width="30px"
                      />
                    </div>
                    <div className="col-6 message">
                      Attach Files(Documents ,Images, Audios & Video files)
                    </div>
                    <div className="col-3">
                      <input
                        type="file"
                        id="actual-btnn"
                        hidden
                        onChange={fileSelect}
                        autoComplete={CommonConstants.autoCompleteInput}
                      />
                      <label style={{ width: "100%" }} htmlFor="actual-btnn">
                        <a
                          variant="contained"
                          component="span"
                          style={{
                            width: "100%",
                            textDecoration: "underline",
                            // backgroundColor: "#198754",
                            color: "red",
                          }}
                          disabled={isLoading}
                        >
                          Choose File
                        </a>
                      </label>
                      {progressBar?.progress > -1 && (
                        <div>
                          <ProgressBarProcess progressBar={progressBar} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row card-row">
                {/* <div className="col-3">
                  <input
                    type="file"
                    id="actual-btn"
                    hidden
                    onChange={fileSelect}
                    accept="image/*,audio/*,video/*,.xls,.xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel6k"
                  />
                  <label style={{ width: "100%" }} htmlFor="actual-btn">
                    <Button
                      variant="contained"
                      component="span"
                      //onClick={this.fileUpload}
                      style={{
                        width: "100%",
                        backgroundColor: "#198754",
                        color: "white",
                      }}
                      disabled={isLoading}
                    >
                      Upload
                    </Button>
                  </label>
                </div> */}
                <div className="col-6 ">
                  <span>{fileName}</span>
                </div>
              </div>

              {fileType?.startsWith("video") && (
                <div className="row card-row">
                  <label className="form-check-label">Upload thumbnail</label>
                  <div className="col-12">
                    <div
                      className="drop-container"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        margin: 0,
                        height: "60px",
                        border: "2px dashed #ced4da",
                      }}
                    >
                      <div className="col-3">
                        <img
                          src={images.upload}
                          className="img-responsive"
                          width="30px"
                        />
                      </div>
                      <div className="col-6 message">Attach thumbnail</div>
                      <div className="col-3">
                        <input
                          ref={inputFileRef}
                          type="file"
                          id="actual-btnn-thumbnail"
                          hidden
                          onChange={(e) => {
                            fileSelect(e, "thumbnail");
                          }}
                          autoComplete={CommonConstants.autoCompleteInput}
                        />
                        <label
                          style={{ width: "100%" }}
                          htmlFor="actual-btnn-thumbnail"
                        >
                          <a
                            variant="contained"
                            component="span"
                            style={{
                              width: "100%",
                              textDecoration: "underline",
                              // backgroundColor: "#198754",
                              color: "red",
                            }}
                            disabled={isLoading}
                          >
                            Choose File
                          </a>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="row card-row">
                {thumbnailFilename && (
                  <div className="col-6 ">
                    <span>{thumbnailFilename}</span>
                    <Button variant="outline-light" size="sm">
                      <Image
                        src={images.del}
                        className="delBtn"
                        onClick={() => {
                          setThumbnail("");
                          setThumbnailFilename("");
                        }}
                      />
                    </Button>
                  </div>
                )}
              </div>

              <div className="row card-row">
                <div className="col-6 ">
                  <div className="form-group">
                    <label className="col-form-label">Keywords</label>

                    <InputForm
                      style={{
                        padding: "0.375rem 2.25rem 0.375rem 0.75rem",
                        height: "35px",
                      }}
                      className="form-control form-control-sm"
                      placeholder={"Keywords"}
                      isDisabled={false}
                      textArea={false}
                      value={keywords}
                      onChange={(e) => onTextChange(e, "keywords")}
                    />
                  </div>
                </div>
                <div className="col-6 ">
                  <div className="form-group">
                    <label className="col-form-label">Hashtags</label>
                    <SelectFormCreatableV2
                      async
                      options={(e, callback) => getHashTags(e, callback)}
                      placeholder="Hastags"
                      // defaultOptions={defaultHastags}
                      isDisabled={false}
                      getOptionLabel={(option) => `#${option.label}`}
                      value={hashtagArray}
                      onChange={(e) => onSelectChange(e, "hashtag")}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    {/* <SelectFormCreatable
                        async
                        options={(e, callback) => getHashTags(e, callback)}
                        placeholder="Hastags"
                        isDisabled={false}
                        value={selectedhashtagArray}
                        onChange={(e) => onSelectChange(e, "hashtag")}
                        isMulti={true}
                        noIndicator={false}
                        noSeparator={false}
                      /> */}

                    {/* {hashtagArray?.map((hashtag) => {
                        return (
                          <li className="hashtagBg">
                            #{hashtag.label}
                            <span
                              className="closeSpan"
                              onClick={(e) =>
                                removeTag(hashtagArray, hashtag.value)
                              }
                            >
                              &#10060;
                            </span>
                          </li>
                        );
                      })} */}
                  </div>
                </div>{" "}
              </div>
              <div className="row card-row">
                <Paper variant="outlined my-3 mx-2">
                  <div className="row rowMargin">
                    <div className="col">
                      <div className="form-group">
                        {/* <Typography variant="h6">
                          Who can see the post?
                        </Typography> */}

                        <label className="form-check-label">
                          Who can see the post?
                        </label>
                        <div className="custom-checkbox">
                          <input
                            //  disabled={editModeIsActive ? true : false}
                            type="checkbox"
                            onChange={(e) => onFDPDCheck(e.target.checked)}
                            name="isActive"
                            checked={globalFDPD}
                            className="isActive mx-2"
                            autoComplete={CommonConstants.autoCompleteInput}
                          />
                          <label className="col-form-label">Global FDPD</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Collapse in={!globalFDPD} timeout="auto" unmountOnExit>
                    <div className={globalFDPDClass}>
                      <div className="col-6">
                        <label className="col-form-label">COE</label>

                        <SelectForm
                          options={coeHideList}
                          placeholder="COE"
                          isDisabled={false}
                          value={selectedCoeHideList}
                          onChange={(e) => setSelectedCoeHideList(e)}
                          isMulti={true}
                          noIndicator={false}
                          noSeparator={false}
                          menuPlacement="top"
                          menuPosition="fixed"
                        />
                      </div>
                      <div className="col-6 ">
                        <div className="form-group">
                          <label className="col-form-label">Users</label>

                          <SelectForm
                            options={tagusersArray}
                            placeholder="Users"
                            isDisabled={false}
                            value={selectedHideUsersArray}
                            onChange={(e) => setSelectedHideUsersArray(e)}
                            isMulti={true}
                            noIndicator={false}
                            noSeparator={false}
                            menuPlacement="top"
                            menuPosition="fixed"
                          />

                          {/* {usersArray?.map((users) => {
                        return (
                          <li className="hashtagBg2">
                            {users.label}
                            <span
                              className="closeSpan"
                              onClick={(e) =>
                                removeUser(usersArray, users.value)
                              }
                            >
                              &#10060;
                            </span>
                          </li>
                        );
                      })} */}
                        </div>{" "}
                      </div>
                    </div>
                  </Collapse>
                </Paper>
              </div>
              <div className="row card-row">
                <div className="col-6 ">
                  <div className="form-group">
                    <label className="col-form-label">Location</label>

                    <InputForm
                      style={{
                        padding: "0.375rem 2.25rem 0.375rem 0.75rem",
                        height: "35px",
                      }}
                      className="form-control form-control-sm"
                      placeholder={"Location"}
                      isDisabled={false}
                      textArea={false}
                      value={location}
                      onChange={(e) => onTextChange(e, "location")}
                    />
                  </div>
                </div>
                {/* <div className="col-6">
                    <label className="col-form-label">Location</label>

                    <SelectForm
                      options={aggregateList}
                      placeholder="COE"
                      isDisabled={false}
                      value={aggregate}
                      onChange={(e) => setAggregate(e.target.value)}
                      isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                    />
                  </div> */}
                <div className="col-6 ">
                  <div className="form-group">
                    <label className="col-form-label">Tag Users</label>

                    <SelectForm
                      options={tagusersArray}
                      placeholder="Tag Users"
                      isDisabled={false}
                      value={selectedTagusersArray}
                      onChange={(e) => setSelectedTagusersArray(e)}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                      menuPlacement="top"
                      menuPosition="fixed"
                    />
                  </div>
                </div>{" "}
              </div>
              <div className="row card-row rowTop">
                <div className="col-3">
                  <button
                    type="reset"
                    className="btn btn-danger"
                    disabled={isLoading}
                    style={{ width: "100%" }}
                    data-bs-dismiss="modal"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                </div>
                <div className="col-3">
                  <button
                    className="btn btn-danger"
                    style={{ width: "100%" }}
                    onClick={(e) => createKnowledge(e)}
                    disabled={isLoading}
                    data-bs-dismiss="modal"
                  >
                    Submit
                  </button>
                  {/* <ToastContainer
                      position="top-center"
                      autoClose={5000}
                      hideProgressBar={true}
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                    /> */}
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </div>

    // </div>
  );
}

export default UploadDocument;

UploadDocument.propTypes = {
  handleModal: PropTypes.func,
};
